import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [authState, setAuthState] = useState({
        token: localStorage.getItem('token') || null,
        role: localStorage.getItem('role') || null,
        isTrainer: localStorage.getItem('trainer') === 'true' || false, // Lisa isTrainer
    });

    // LocalStorage sünk
    useEffect(() => {
        if (authState.token) {
            localStorage.setItem('token', authState.token);
        } else {
            localStorage.removeItem('token');
        }
        if (authState.role) {
            localStorage.setItem('role', authState.role);
        } else {
            localStorage.removeItem('role');
        }
        if (authState.isTrainer) {
            localStorage.setItem('trainer', 'true');
        } else {
            localStorage.removeItem('trainer');
        }
    }, [authState]);

    const isLoggedIn = !!authState.token;

    const setToken = (token) => {
        setAuthState((prev) => ({ ...prev, token }));
    };

    const setRole = (role) => {
        setAuthState((prev) => ({ ...prev, role }));
    };

    const setIsTrainer = (isTrainer) => {
        setAuthState((prev) => ({ ...prev, isTrainer }));
    };

    // NB! võtab `navigate` argumendina
    const logout = (navigate) => {
        setAuthState({ token: null, role: null, isTrainer: false });
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('affiliateId');
        localStorage.removeItem('affiliateName');
        localStorage.removeItem('selectedAffiliate');
        localStorage.removeItem('checkout_planData');
        localStorage.removeItem('checkout_affiliateInfo');
        localStorage.removeItem('checkout_contract');
        localStorage.removeItem('checkout_appliedCredit');
        localStorage.removeItem('checkout_userData');
        localStorage.removeItem('checkout_isContractPayment');
        localStorage.removeItem('pricingPlan');
        localStorage.removeItem('trainer'); // Eemaldame treeneri info, kui see on olemas

        // suuna avalehele (või kuhu vaja)
        if (navigate) {
            navigate('/');
        }
    };

    return (
        <AuthContext.Provider
            value={{
                token: authState.token,
                role: authState.role,
                isTrainer: authState.isTrainer, // Lisa isTrainer
                isLoggedIn,
                setToken,
                setRole,
                setIsTrainer, // Lisa setIsTrainer
                logout,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}